import { render, staticRenderFns } from "./EditOffice.vue?vue&type=template&id=2cc4c0ca&scoped=true&"
import script from "./EditOffice.vue?vue&type=script&lang=js&"
export * from "./EditOffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc4c0ca",
  null
  
)

export default component.exports